var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1.66797H4.99992C4.55789 1.66797 4.13397 1.84356 3.82141 2.15612C3.50885 2.46868 3.33325 2.89261 3.33325 3.33464V16.668C3.33325 17.11 3.50885 17.5339 3.82141 17.8465C4.13397 18.159 4.55789 18.3346 4.99992 18.3346H14.9999C15.4419 18.3346 15.8659 18.159 16.1784 17.8465C16.491 17.5339 16.6666 17.11 16.6666 16.668V6.66797M11.6666 1.66797L16.6666 6.66797M11.6666 1.66797V6.66797H16.6666M13.3333 10.8346H6.66659M13.3333 14.168H6.66659M8.33325 7.5013H6.66659",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.5f68695a0dba83eef6de3203e31d70dd.svg";
export { ForwardRef as ReactComponent };